import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxIconComponent } from '../../icons/onyx-icon/onyx-icon.component';
import type { OnyxChip } from '../interfaces';

@Component({
  selector: 'onyx-chip',
  imports: [TranslatePipe, OnyxIconComponent],
  templateUrl: './onyx-chip.component.html',
  styleUrl: './onyx-chip.component.scss',
})
export class OnyxChipComponent<T> {
  public readonly chip = input.required<OnyxChip<T>>();
  public readonly active = input.required<boolean>();
  public readonly variant = input<
    'primary' | 'secondary' | 'tertiary' | 'group'
  >('primary');
  public readonly disabled = input(false);
}
